import {
    LIVE_COLLABORATION_SOCKET_CONNECT,
    LIVE_COLLABORATION_SOCKET_DISCONNECT,
    LIVE_COLLABORATION_SOCKET_UPDATE_CHANNEL,
} from '../liveCollaborationConstants';

export const liveCollaborationSocketConnect = ({ channel, userId }) => ({
    type: LIVE_COLLABORATION_SOCKET_CONNECT,
    channel,
    userId,
});
export const liveCollaborationSocketDisconnect = () => ({ type: LIVE_COLLABORATION_SOCKET_DISCONNECT });
export const liveCollaborationSocketUpdateChannel = (channel) => ({
    type: LIVE_COLLABORATION_SOCKET_UPDATE_CHANNEL,
    channel,
});
